module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epigraphs"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("“Set in a time made thick with societal rules and regulations, Erica Vetsch’s "), _c('em', [_vm._v("Millstone of Doubt")]), _vm._v(" weaves a classic tale of how the old affects the new. An artfully told story that will have you wondering at the outcome until the final pages are read.”")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("—Ruth Logan Herne, "), _c('em', [_vm._v("USA Today")]), _vm._v(" best-selling author")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“I’ve been eagerly awaiting "), _c('em', [_vm._v("Millstone of Doubt")]), _vm._v(" ever since I read the first book in this series. This novel proved every bit as riveting, with characters I’d already come to know and love. A diverse cast offers endless wit and fascinating, well-rounded perspectives, and intrigues that are layered and textured. It’s the perfect combination for a fully satisfying mystery. I can’t wait to read the next one!”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("—Jocelyn Green, Christy Award–winning author of "), _c('em', [_vm._v("Drawn by the Current")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“"), _c('em', [_vm._v("Millstone of Doubt")]), _vm._v(" is a romantic Regency mystery, beautifully threaded with God’s grace. I am sure fans of the first book in this series will revel in the deepening relationship between Daniel Swann and Juliette Thorndike.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("—Alissa Baxter, author of "), _c('em', [_vm._v("The Viscount’s Lady Novelist")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“"), _c('em', [_vm._v("Millstone of Doubt")]), _vm._v(" captivated me from the first sentence and kept me guessing the entire novel. Suspense and intrigue held me on the edge of my seat, suspecting various red herring characters of their part in the murder. I laughed over Lady Juliette’s predicaments as the elegant but feisty heroine developed her craft spying for the crown. The dashing and intelligent Bow Street runner, Daniel Swann, comes to life as the hero with his hidden insecurities and quirks.")])]), _c('p', {
    staticClass: "epigraph1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('em', [_vm._v("Millstone of Doubt")]), _vm._v(" weaves an artful blend of the opulent splendor of the aristocracy and the grit and sweat of the working classes, and the underlying current of tension between the two sustains throughout the ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("story. Erica Vetsch is the master of all things Regency. Her keen eye for historical detail, rhetoric, and knowledge of people and customs place readers inside a delightful era of history.”")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("—Lorri Dudley, author of "), _c('em', [_vm._v("The Duke’s Refuge")]), _vm._v(" and the Leeward Islands series")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ee9af70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/001_FM01.vue
// module id = 57
// module chunks = 0